"use client";

import { SessionProvider } from "next-auth/react";
import { PwaRegister } from "@/components/PwaRegister";
import { ThemeProvider } from "@/components/ThemeProvider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <ThemeProvider>
        <PwaRegister />
        {children}
      </ThemeProvider>
    </SessionProvider>
  );
}
